// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles__cardsContainer___2bMYT","singleCard":"styles__singleCard___1fJH6","cardNavigation":"styles__cardNavigation___3Eyap"};